import React, { VFC } from 'react';
import { TFunction } from 'react-i18next';
import { Box, Alert, makeStyles } from '@dxb-web-ui-framework/design-system';
import { GenericDialog } from '../../../../../content-composer/src/components/Generic/GenericDialog/GenericDialog';
import { DialogAction } from '../../../../../content-composer/src/components/Generic/types';

export interface DealerRateErrorDialogProps {
  t: TFunction;
  isOpen: boolean;
  setIsOpen: Function;
  onRetry?: React.MouseEventHandler<HTMLButtonElement>;
  onCancel?: React.MouseEventHandler<HTMLButtonElement>;
}

const useStyles = makeStyles(theme => ({
  dialogContent: {
    marginBottom: theme.spacing(5),
  },
}));

const DealerRateErrorDialog: VFC<DealerRateErrorDialogProps> = ({
  t,
  isOpen,
  setIsOpen,
  onRetry = () => {},
  onCancel = () => {},
}) => {
  const onCancelBtnClick: React.MouseEventHandler<HTMLButtonElement> = e => {
    setIsOpen(false);
    onCancel(e);
  };

  const onRetryBtnClick: React.MouseEventHandler<HTMLButtonElement> = e => {
    setIsOpen(false);
    onRetry(e);
  };

  const dialogActions: DialogAction[] = [
    {
      onClick: onCancelBtnClick,
      label: t('transactionDetails.RequestDealerRate.cancelButton.Label'),
      color: 'primary',
      variant: 'outlined',
    },
    {
      onClick: onRetryBtnClick,
      label: t('transactionDetails.RequestDealerRate.confirmButton.Label'),
      color: 'primary',
      variant: 'contained',
    },
  ];

  const classes = useStyles();

  return (
    <>
      <GenericDialog
        fullwidth
        isError={false}
        isLoading={false}
        isConfirmationResponsiveDialog={true}
        dialogContentClassName={classes.dialogContent}
        isDialogOpen={isOpen}
        onToggleDialog={() => setIsOpen(false)}
        stickDrawerTitleToLeft={true}
        disableMobileDrawerHeight={true}
        dialogTitle={t('fundsTransferPage.RequestDealerRate.Generic.Text')}
        loaderVerticalSpacing='large'
        dialogContent={
          <Box mt={3}>
            <Alert icon={false} severity='error' variant='filled'>
              {t('transactionDetails.RequestDealerRate.Error.Message')}
            </Alert>
          </Box>
        }
        isSuccess={false}
        dialogActions={dialogActions}
      />
    </>
  );
};

export { DealerRateErrorDialog };
